import { useState } from "react";
import { toast } from "sonner";
import { FileCheck2, Send, Loader2 } from "lucide-react";
import { useClinic } from "@/store/ClinicContext";

const DEFAULT_TEXT = "Paciente necessita de afastamento de suas atividades laborais/escolares pelo período especificado, por motivo de saúde, sob meus cuidados médicos.";

export const AtestadoTab = ({ patient }) => {
  const { emitAtestado } = useClinic();
  const [cid, setCid] = useState("");
  const [start, setStart] = useState(new Date().toISOString().slice(0, 10));
  const [days, setDays] = useState(1);
  const [justification, setJustification] = useState(DEFAULT_TEXT);
  const [sending, setSending] = useState(false);

  const emitir = async () => {
    if (!patient?.name) return toast.error("Selecione um paciente.");
    if (!patient?.email) return toast.error("Paciente sem e-mail cadastrado.", { description: "Edite o paciente e adicione um e-mail para enviar o atestado." });
    if (!start) return toast.error("Informe a data de início do afastamento.");
    if (sending) return;
    setSending(true);
    try {
      const d = await emitAtestado({ patient: patient.name, patient_email: patient.email, cid, start_date: start, days: Number(days) || 1, justification });
      toast.success("Atestado enviado por e-mail!", { description: `PDF enviado para ${d.sent_to}` });
    } catch (e) {
      toast.error("Falha ao emitir atestado", { description: e.message });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="atestado-tab">
      <div className="flex items-center gap-2 rounded-xl border border-blue-100 bg-blue-50/60 p-3 text-sm text-blue-800">
        <FileCheck2 className="h-5 w-5 shrink-0 text-blue-600" />
        <span>O atestado é gerado em PDF com seus dados (CRM) e enviado por e-mail ao paciente <b>{patient?.name || "—"}</b>{patient?.email ? ` (${patient.email})` : " (sem e-mail cadastrado)"}.</span>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <div>
          <label className="text-xs font-semibold text-slate-600">CID (opcional)</label>
          <input data-testid="atestado-cid" value={cid} onChange={(e) => setCid(e.target.value)} placeholder="Ex.: J11" className="mt-1.5 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">Início do afastamento</label>
          <input data-testid="atestado-start" type="date" value={start} onChange={(e) => setStart(e.target.value)} className="mt-1.5 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">Dias de repouso</label>
          <input data-testid="atestado-days" type="number" min={1} value={days} onChange={(e) => setDays(e.target.value)} className="mt-1.5 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" />
        </div>
      </div>

      <div>
        <label className="text-xs font-semibold text-slate-600">Texto / Justificativa</label>
        <textarea data-testid="atestado-text" value={justification} onChange={(e) => setJustification(e.target.value)} rows={4} className="mt-1.5 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" />
      </div>

      <button data-testid="atestado-emit-btn" onClick={emitir} disabled={sending} className="flex items-center justify-center gap-2 rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-blue-700 disabled:opacity-60">
        {sending ? <><Loader2 className="h-4 w-4 animate-spin" />Gerando e enviando...</> : <><Send className="h-4 w-4" />Emitir e enviar por e-mail</>}
      </button>
    </div>
  );
};
